import { apiActionCreator, types } from "@authzsvc/api-lib";

export const logout = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.LOGOUT));

export const getIdentity = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_IDENTITY, { queryFilter: null }));

export const getAllMyResources = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_ALL_MY_RESOURCES));

export const getAllResourcesOfResourceType =
  (resourceType, queryFilter) => async (dispatch) => {
    if (resourceType.toLowerCase() === "account") {
      return await dispatch(
        apiActionCreator(types.GET_CURRENT_IDENTITY_ACCOUNTS),
      );
    }

    return await dispatch(
      apiActionCreator(types.GET_ALL_RESOURCES_OF_RESOURCE_TYPE, {
        resourceType,
        queryFilter,
      }),
    );
  };

export const getGroupById = (id) => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_GROUP_BY_ID, { id }));

export const deleteResource = (item, itemType) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.DELETE_RESOURCE, {
      itemType: item.managedResourceType || itemType,
      id: item.id,
    }),
  );

export const updateResource =
  (data, resourceType = null) =>
  async (dispatch) =>
    await dispatch(
      apiActionCreator(types.UPDATE_RESOURCE, {
        itemType: data.managedResourceType || resourceType,
        id: data.id,
        body: data,
      }),
    );

export const patchResource =
  (resourceType, resourceId, data) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.PATCH_RESOURCE, {
        itemType: resourceType,
        id: resourceId,
        body: data,
      }),
    );

export const transferResourceOwner =
  (resourceType, resourceId, ownerId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.TRANSFER_RESOURCE_OWNER, {
        itemType: resourceType,
        id: resourceId,
        ownerId: ownerId,
      }),
    );

export const getApplication = (applicationIdentifier) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_APPLICATION, {
      applicationid: applicationIdentifier,
    }),
  );

export const getGroupsForRoleById = (roleId) => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_GROUPS_FOR_ROLE_BY_ID, { roleId }));

export const subscribeCurrentIdentityToGroups = (body) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.SUBSCRIBE_CURRENT_IDENTITY_TO_GROUPS, { body }),
  );

export const unsubscribeCurrentIdentityFromGroups =
  (body) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.UNSUBSCRIBE_CURRENT_IDENTITY_FROM_GROUPS, {
        body,
      }),
    );

// Eligibility new endpoints
export const getServiceCollectionsWithEligibilityStatus =
  () => async (dispatch) =>
    await dispatch(
      apiActionCreator(
        types.GET_SERVICE_COLLECTIONS_WITH_ELIGIBLITY_STATUS,
        {},
      ),
    );

export const getServiceCollections = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_SERVICE_COLLECTIONS, {}));

export const getApplicationListV2 = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_APPLICATION_LIST_V2, {}));

export const getServiceCollection = (serviceId) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_SERVICE_COLLECTION, {
      serviceId,
    }),
  );

export const postServiceCollection = (serviceCollection) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.POST_SERVICE_COLLECTION, {
      serviceCollection,
    }),
  );

export const getServiceApplicationsInServiceCollection =
  (serviceId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_SERVICE_APPLICATIONS_IN_SERVICE_COLLECTION, {
        serviceId,
      }),
    );

export const getServiceApplicationSubscriptionStatusForIdentity =
  (applicationId, identityId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(
        types.GET_SERVICE_APPLICATION_SUBSCRIPTION_STATUS_FOR_IDENTITY,
        {
          applicationId,
          identityId,
        },
      ),
    );

export const getServiceCollectionSubscriptionStatusForIdentity =
  (serviceId, identityId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(
        types.GET_SERVICE_COLLECTION_SUBSCRIPTION_STATUS_FOR_IDENTITY,
        {
          serviceId,
          identityId,
        },
      ),
    );

export const getServiceApplicationSubscriptionSettings =
  (applicationId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_SERVICE_APPLICATION_SUBSCRIPTION_SETTINGS, {
        applicationId,
      }),
    );

export const putServiceApplicationSubscriptionSettings =
  (applicationId, subscriptionSettings) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.PUT_SERVICE_APPLICATION_SUBSCRIPTION_SETTINGS, {
        applicationId,
        subscriptionSettings,
      }),
    );

export const getServiceCollectionEligibilitySettings =
  (serviceId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS, {
        serviceId,
      }),
    );

export const putServiceCollectionEligibilitySettings =
  (serviceId, eligibilitySettings) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.PUT_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS, {
        serviceId,
        eligibilitySettings,
      }),
    );

export const getGroupsForRoleById2 =
  (applicationId, roleId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_GROUPS_FOR_ROLE_BY_ID2, {
        applicationId,
        roleId,
      }),
    );

export const getRolesForApplication = (applicationId) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_ROLES_FOR_APPLICATION, {
      applicationId,
    }),
  );

export const searchMyApplications =
  (queryFilter, limit = 30) =>
  async (dispatch) =>
    await dispatch(
      apiActionCreator(types.SEARCH_MY_APPLICATIONS, {
        queryFilter,
        limit,
      }),
    );

export const searchAllApplications =
  (queryFilter, limit = 30) =>
  async (dispatch) =>
    await dispatch(
      apiActionCreator(types.SEARCH_ALL_APPLICATIONS, {
        queryFilter,
        limit,
      }),
    );

export const linkServiceApplicationToServiceCollection =
  (serviceId, applicationId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.LINK_SERVICE_APPLICATION_TO_SERVICE_COLLECTION, {
        serviceId,
        applicationId,
      }),
    );

export const unlinkServiceApplicationFromServiceCollection =
  (applicationId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(
        types.UNLINK_SERVICE_APPLICATION_FROM_SERVICE_COLLECTION,
        {
          applicationId,
        },
      ),
    );

export const postCreateManagedResourceType =
  (managedResourceType) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.POST_CREATE_MANAGED_RESOURCE_TYPE, {
        managedResourceType,
      }),
    );

export const putUpdateManagedResourceType =
  (managedResourceTypeId, managedResourceType) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.PUT_UPDATE_MANAGED_RESOURCE_TYPE, {
        managedResourceTypeId,
        managedResourceType,
      }),
    );

export const deleteManagedResourceType =
  (managedResourceTypeId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.DELETE_MANAGED_RESOURCE_TYPE, {
        managedResourceTypeId,
      }),
    );

// Deprecated (jira #77), replaced by call below
// export const getManagedResourceTypesInApplicationSubscription =
//   (applicationSubscriptionId) => async (dispatch) =>
//     await dispatch(
//       apiActionCreator(
//         types.GET_MANAGED_RESOURCE_TYPES_IN_APPLICATION_SUBSCRIPTION,
//         {
//           applicationSubscriptionId,
//         },
//       ),
//     );

export const getManagedResourceTypesInApplication =
  (applicationId) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_MANAGED_RESOURCE_TYPES_IN_APPLICATION, {
        applicationId,
      }),
    );

export const getMyResourcesInManagedResourceType =
  (managedResourceType, queryFilter) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_MY_RESOURCES_IN_MANAGED_RESOURCE_TYPE, {
        managedResourceType,
        queryFilter,
      }),
    );

export const getMyGroups = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_MY_GROUPS, { queryFilter: null }));

export const getManagedResourceType =
  (managedResourceTypeName) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_MANAGED_RESOURCE_TYPE, {
        managedResourceTypeName,
      }),
    );

export const getServiceApplicationTags = (applicationId) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_SERVICE_APPLICATION_TAGS, {
      applicationId,
    }),
  );

export const postServiceApplicationTags =
  (applicationId, tagName) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.POST_SERVICE_APPLICATION_TAGS, {
        applicationId,
        tagName,
      }),
    );

// api-lib shoudl be fixed applicationid -> applicationId and roleid -> roleId
export const getRoleForApplication =
  (applicationid, roleid) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_ROLE_FOR_APPLICATION, {
        applicationid,
        roleid,
      }),
    );
